import { SIGNUP_REQUEST, SIGNUP_SUCCESS, SIGNUP_FAILURE } from "./actionTypes"

export const signupRequest = userData => ({
  type: SIGNUP_REQUEST,
  payload: userData,
})

export const signupSuccess = user => ({
  type: SIGNUP_SUCCESS,
  payload: user,
})

export const signupFailure = error => ({
  type: SIGNUP_FAILURE,
  payload: error,
})
